var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client/react';
import { DocumentType, SignRequestStatus, Unstable_Feature as Feature } from 'shared/domains/apollo/generated/types';
import { PleditorDownloadAvailableDataDocument } from './PleditorDownloadAvailableData.gql';
const ESIGNING_LOCKED_STATUSES = [
    SignRequestStatus.Creating,
    SignRequestStatus.Pending,
    SignRequestStatus.Signed,
    SignRequestStatus.Cancelling,
];
export const usePleditorDownloadAvailable = (documentId) => {
    var _a;
    const _b = useQuery(PleditorDownloadAvailableDataDocument, {
        variables: { documentId },
    }), { data } = _b, rest = __rest(_b, ["data"]);
    const { fileSystemDocument, companyFeatures } = data || {};
    const { type, name } = fileSystemDocument || {};
    const { status } = (_a = fileSystemDocument === null || fileSystemDocument === void 0 ? void 0 : fileSystemDocument.lastSignRequest) !== null && _a !== void 0 ? _a : {};
    const isEditorImportExportEnabled = (companyFeatures === null || companyFeatures === void 0 ? void 0 : companyFeatures.some((feature) => feature.featureId === Feature.EditorImportExport)) || false;
    const isPleditorDownloadAvailable = isEditorImportExportEnabled && (type === DocumentType.Composed || type === DocumentType.Freetext);
    const isEsigningLocked = status && ESIGNING_LOCKED_STATUSES.includes(status);
    const getLockedReason = () => {
        if (isEsigningLocked) {
            return `ESIGNING:${status}`;
        }
        return undefined;
    };
    const document = {
        name: name || '',
        type: type || DocumentType.Unknown,
        lockedReason: getLockedReason(),
    };
    return Object.assign(Object.assign({}, rest), { isPleditorDownloadAvailable, document });
};
